import { createTheme, Theme, ThemeOptions } from '@mui/material';
import { palette, darkPalette } from './palette';
import { typography } from './typography';
import { MuiAlert } from './componentOverrides/MuiAlert';
import { MuiAvatar } from './componentOverrides/MuiAvatar';
import { getMuiButton } from './componentOverrides/MuiButton';
import { MuiCheckbox } from './componentOverrides/MuiCheckbox';
import { getMuiChip } from './componentOverrides/MuiChip';
import { MuiDialog } from './componentOverrides/MuiDialog';
import { MuiFormControl } from './componentOverrides/MuiFormControl';
import { getMuiIconButton } from './componentOverrides/MuiIconButton';
import { MuiSelect } from './componentOverrides/MuiSelect';
import { MuiSvgIcon } from './componentOverrides/MuiSvgIcon';
import { MuiSwitch } from './componentOverrides/MuiSwitch';
import { getMuiTab } from './componentOverrides/MuiTab';
import { getMuiTabs } from './componentOverrides/MuiTabs';
import { MuiTextField } from './componentOverrides/MuiTextField';
import { getMuiToggleButton } from './componentOverrides/MuiToggleButton';
import { MuiToggleButtonGroup } from './componentOverrides/MuiToggleButtonGroup';
import { getMuiTooltip } from './componentOverrides/MuiTooltip';
import { MuiTypography } from './componentOverrides/MuiTypography';

// Shared base theme configuration
const baseThemeConfig = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      laptop: 1024,
      tablet: 768,
      phone: 480,
    },
  },
  shape: {
    borderRadius: 6,
  },
  typography,
};

const createCustomTheme = (
  options: Omit<ThemeOptions, 'components'>,
): Theme => {
  const baseTheme = createTheme({
    ...baseThemeConfig,
    ...options,
  });

  return createTheme(baseTheme, {
    components: {
      MuiFormControl,
      MuiCheckbox,
      MuiDialog,
      MuiSwitch,
      MuiButton: getMuiButton(baseTheme),
      MuiIconButton: getMuiIconButton(baseTheme),
      MuiToggleButton: getMuiToggleButton(),
      MuiToggleButtonGroup,
      MuiTextField,
      MuiSelect,
      MuiAlert,
      MuiAvatar,
      MuiSvgIcon,
      MuiChip: getMuiChip(baseTheme),
      MuiTypography,
      MuiTabs: getMuiTabs(baseTheme),
      MuiTab: getMuiTab(baseTheme),
      MuiTooltip: getMuiTooltip(baseTheme),
    },
  });
};

export const watchdutyTheme = createCustomTheme({
  palette,
});

export const watchdutyDarkTheme = createCustomTheme({
  palette: darkPalette,
});
